/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_A1Inputs */

const en_guide_what_is_json_faq_a1 = /** @type {(inputs: Guide_What_Is_Json_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. JSON is a data format inspired by JavaScript object syntax, but it is language-independent. JSON has stricter rules than JavaScript: for example, keys must be in double quotes and trailing commas are not allowed.`)
};

const ko_guide_what_is_json_faq_a1 = /** @type {(inputs: Guide_What_Is_Json_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. JSON은 JavaScript 객체 구문에서 영감을 받은 데이터 포맷이지만, 언어에 독립적입니다. JSON은 JavaScript보다 엄격한 규칙을 가지고 있습니다: 예를 들어, 키는 반드시 큰따옴표로 감싸야 하고 후행 쉼표는 허용되지 않습니다.`)
};

const ja_guide_what_is_json_faq_a1 = /** @type {(inputs: Guide_What_Is_Json_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。JSONはJavaScriptのオブジェクト構文に触発されたデータ形式ですが、言語に依存しません。JSONにはJavaScriptよりも厳しいルールがあります: 例えば、キーはダブルクォートで囲む必要があり、末尾のカンマは許可されていません。`)
};

/**
* | output |
* | --- |
* | "No. JSON is a data format inspired by JavaScript object syntax, but it is language-independent. JSON has stricter rules than JavaScript: for example, keys mu..." |
*
* @param {Guide_What_Is_Json_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_a1 = /** @type {((inputs?: Guide_What_Is_Json_Faq_A1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_A1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_a1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_a1(inputs)
	return ja_guide_what_is_json_faq_a1(inputs)
});